import styled from 'styled-components'

export const ResumeAppSubtitle = styled.div`
  font-size: 18px;
`
